export const environment = {
  production: true,
  logErrors: false,
};
